import { jsx as _jsx } from "react/jsx-runtime";
const ChevronRight = () => (_jsx("svg", Object.assign({ id: "Icons", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16" }, { children: _jsx("polygon", { points: "10.29 8 4.79 13.5 5.5 14.21 11.71 8 5.5 1.79 4.79 2.5 10.29 8" }) })));
export default ChevronRight;
